




















































import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { INSPIRATION_CREATE, INSPIRATION_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import InspirationFilterModel from "@models/inspirations/inspirationFilterModel";

@Component
export default class PageInspirationComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: InspirationFilterModel = new InspirationFilterModel();
  columnNames = ["#",
                // "Картинка",
                "Название",
                "Добавлено",
                "",
                ""];
  createRouteName = INSPIRATION_CREATE;
  editRouteName = INSPIRATION_EDIT;
  getDataFunc = this.$api.InspirationService.getListAsync.bind(
    this.$api.InspirationService
  );
  removeFunc = this.$api.InspirationService.deleteAsync.bind(
    this.$api.InspirationService
  );
  async created() {}
  async startDelete(item: CategoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
